/* eslint-disable consistent-return */
/* eslint-disable react/no-array-index-key */
/* eslint-disable max-len */
/* eslint-disable react/react-in-jsx-scope */
import { useState, useEffect } from 'react';
import { showNotification } from '@mantine/notifications';
import { CircleCheck, Copy, ReportMoney } from 'tabler-icons-react';
import {
  ActionIcon, Checkbox, CopyButton, Tooltip, useMantineColorScheme,
} from '@mantine/core';
import Layout from '../../Layout/Layout';
import useSorting from '../../../components/CommonFunction/useSorting';
import { loadingStates, assetPrefix, renderNumber } from '../../../utilities/general';
import { apiWrapWithErrorWithData } from '../../../utilities/apis/apiHelpers';
import styles from './ColdWallet.module.css';
import ColdWalletTabLoading from '../../../components/LoadingPlaceholder/ColdWalletTabLoading';
import { tradersColdWalletApi, tradersColdWalletOverviewApi, tradersListApi } from '../../../utilities/apis/traders';
// import { dummyChartData } from './BalanceSheet/dummy';
import FilterExpansionComponent from './FilterExpansionComponent';
import ColdWalletLoading from '../../../components/LoadingPlaceholder/ColdWalletLoading';
import AreaChartNew from './AreaChartNew';

const ColdWallet = () => {
  const [coldWalletData, setColdWalletData] = useState(null);
  const [traderColdWalletOverView, setTraderColdWalletOverView] = useState(null);
  const [filteredColdWalletData, setFilteredColdWalletData] = useState(null);
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [dataLoading, setDataLoading] = useState(loadingStates.NO_ACTIVE_REQUEST);
  const [checkboxes, setCheckboxes] = useState({
    filter: false,
    removeDust: true,
  });

  const { colorScheme } = useMantineColorScheme();

  const handleChange = (event) => {
    const { name, checked } = event.currentTarget;
    setCheckboxes((prevState) => ({
      ...prevState,
      [name]: checked,
    }));
  };

  const fetchTraderColdWalletOverview = async (userId) => {
    setDataLoading(loadingStates.LOADING);
    const resp = await apiWrapWithErrorWithData(tradersColdWalletOverviewApi(userId));

    if (resp?.success) {
      setTraderColdWalletOverView(resp?.data);
    } else {
      showNotification({
        color: 'red',
        message: 'Could not load trader cold wallet overview',
        title: 'Error while fetching cold wallet overview',
      });
    }
  };

  const fetchColdWalletData = async (userId) => {
    setDataLoading(loadingStates.LOADING);
    const resp = await apiWrapWithErrorWithData(tradersColdWalletApi(userId));
    if (resp?.success && resp?.data) {
      setColdWalletData(resp?.data);
      setFilteredColdWalletData(resp?.data);
      setDataLoading(loadingStates.FINISHED);
    } else {
      showNotification({
        color: 'red',
        message: 'Could not load cold wallet',
        title: 'Error while fetching cold wallet',
      });
    }
  };

  const getTradersListingData = async () => {
    setDataLoading(loadingStates.LOADING);
    const traderListResp = await apiWrapWithErrorWithData(tradersListApi());
    if (traderListResp?.success) {
      const accountId = traderListResp.data?.[0].accountId;
      fetchTraderColdWalletOverview(accountId);
      fetchColdWalletData(accountId);
    } else {
      showNotification({
        color: 'red',
        title: 'Error',
        message: 'Failed to load traders list.',
      });
    }
  };

  useEffect(() => {
    getTradersListingData();
  }, []);

  useEffect(() => {
    if (!checkboxes.filter && isFilterActive) {
      getTradersListingData();
    }
  }, [checkboxes.filter, isFilterActive]);

  const newlyUpdatedData = filteredColdWalletData?.filter((newItem) => newItem?.totalValueUsd >= 1);

  const { items, requestSort, sortConfig } = useSorting(checkboxes?.removeDust ? newlyUpdatedData : filteredColdWalletData, 'totalValueUsd');

  const getClassNamesFor = (name) => {
    if (!sortConfig) {
      return;
    }
    return sortConfig.key === name ? sortConfig.direction : undefined;
  };

  const traderColdWalletOverViewData = traderColdWalletOverView?.oneMonthData.map((item) => ({
    ...item,
    value: item.totalValueUsd,
  }));

  return (
    <div
      className="w-full flex h-full"
    >
      <Layout>
        <div className="flex flex-col w-[90%] mx-auto mt-4 px-4 gap-[18px]">
          <div className="flex flex-col gap-4 bg-white dark:bg-[#26282C] text-base rounded-md">
            {
              dataLoading === loadingStates.LOADING
              && <ColdWalletLoading />
            }
            {dataLoading === loadingStates.FINISHED && (
              <div className="flex h-36 px-7 py-3 items-center w-full">
                <div className="text-[#3A3A3A] font-semibold text-[26px] dark:text-[#F2F2F2] p-2 w-[25%]">
                  Cold Wallet
                </div>
                <div className="w-[50%] mb-6 mr-2 h-40">
                  <AreaChartNew
                    chartId="ColdWalletOverview"
                    days="30 Days"
                    chartData={traderColdWalletOverViewData}
                  />
                </div>
                <div className="flex flex-col h-full justify-center items-end p-2 w-[25%]">
                  <div className="flex flex-col items-center">
                    <span className={`${styles.valueText} text-[#33B1FF]`}>
                      {/* {renderNumber(traderColdWalletOverView?.totalValueUsd ?? 64380.07, true)} */}
                      {renderNumber(traderColdWalletOverView?.totalValueUsd, true)}
                    </span>
                    <span className={`${styles.Text}`}>Value of Cold Wallet</span>
                  </div>
                </div>
              </div>
            )}

          </div>
          <div className={`bg-white dark:bg-[#26282C] font-semibold rounded-md pb-5 ${colorScheme === 'dark' && styles.dark}`}>
            <div className="!p-0 mb-0 rounded-lg">
              {checkboxes.filter && (
                <FilterExpansionComponent
                  data={checkboxes?.removeDust ? newlyUpdatedData : filteredColdWalletData}
                  setData={setFilteredColdWalletData}
                  currentTab="coldWalletTab"
                  originalData={checkboxes?.removeDust ? newlyUpdatedData : coldWalletData}
                  setIsFilterActive={setIsFilterActive}
                />
              )}
            </div>
            <div className="pt-5 px-2.5">
              <div className={`grid items-start transition-transform cursor-pointer h-10 px-5 ${styles.ColdWalletHeadingGrid}`}>
                <div
                  className="text-sm font-bold flex"
                >
                  <span
                    onClick={() => requestSort('address')}
                    className={getClassNamesFor('address')}
                  >
                    Address
                  </span>
                </div>
                <div className="text-sm font-bold flex gap-3">
                  <span
                    onClick={() => requestSort('token')}
                    className={getClassNamesFor('token')}
                  >
                    Asset
                  </span>
                </div>
                <div className="text-sm font-bold flex gap-3">
                  <span
                    onClick={() => requestSort('quantity')}
                    className={getClassNamesFor('quantity')}
                  >
                    Quantity
                  </span>
                </div>
                <div className="text-sm font-bold flex gap-3">
                  <span
                    onClick={() => requestSort('currentPriceUsd')}
                    className={getClassNamesFor('currentPriceUsd')}
                  >
                    Current Price
                  </span>
                </div>
                <div className="text-sm font-bold flex gap-3">
                  <span
                    onClick={() => requestSort('totalValueUsd')}
                    className={getClassNamesFor('totalValueUsd')}
                  >
                    Total Value
                  </span>
                </div>
                <div className="text-sm font-bold flex gap-3">
                  <span
                    onClick={() => requestSort('dollarCostAvg')}
                    className={getClassNamesFor('dollarCostAvg')}
                  >
                    Dollar Cost Avg
                  </span>
                </div>
                {/* <div className="text-sm font-bold flex gap-3">
                  <span>
                    Percentage
                  </span>
                </div> */}

              </div>
              <div className={`grid text-xs font-normal text-[#898989] ml-[1.8%] pb-2 py-1.5 ${styles.coldWalletSubHeadingGrid}`}>
                <div className="flex gap-2.5 font-bold mt-0">
                  <Checkbox
                    styles={{
                      label: {
                        paddingLeft: 4,
                      },
                    }}
                    label="Filter"
                    name="filter"
                    checked={checkboxes.filter}
                    onChange={handleChange}
                    size="xs"
                    disabled={coldWalletData?.length === 0}
                  />
                  <Checkbox
                    styles={{
                      label: {
                        paddingLeft: 4,
                      },
                    }}
                    label="Remove Dust"
                    name="removeDust"
                    checked={checkboxes.removeDust}
                    onChange={handleChange}
                    size="xs"
                    disabled={coldWalletData?.length === 0}
                  />
                </div>
                <div>
                  USD
                </div>
                <div>
                  USD
                </div>
              </div>
              <div className={`custom-scrollbar-css flex flex-col gap-3 ${checkboxes.filter ? 'max-h-[calc(100vh-450px)] 2xl:max-h-[calc(100vh-460px)]' : 'max-h-[calc(100vh-392px)] 2xl:max-h-[calc(100vh-422px)]'} overflow-y-auto pr-2`}>
                <div className="mt-3 bg-white dark:bg-[#26282C]">
                  {dataLoading === loadingStates.LOADING && <ColdWalletTabLoading />}
                  {dataLoading === loadingStates.FINISHED && !!items.length && items.map((value) => (
                    <div className={`darkClass ${styles.rowContainer} ${styles.shortRow}`}>
                      <div className={`grid items-center transition-transform px-5 py-3.5 textColor ${styles.ColdWalletRowGrid}`}>
                        <div className="text-base font-normal flex items-start">
                          <Tooltip withArrow label={value?.address}>
                            <span>
                              {value?.address?.length > 10 ? `${value?.address?.slice(0, 16)}...` : value?.address || '-'}
                            </span>
                          </Tooltip>
                          {value?.address?.length
                            && (
                              <CopyButton value={value?.address && value?.address}>
                                {({ copied, copy }) => (
                                  <Tooltip withArrow label={copied ? 'Copied' : 'Copy'}>
                                    <ActionIcon color={copied ? 'teal' : 'gray'} onClick={copy} sx={{ alignItems: 'baseline' }}>
                                      {copied ? (
                                        <CircleCheck
                                          size="1.2rem"
                                        />
                                      ) : (
                                        <Copy
                                          size="1.2rem"
                                          strokeWidth={2}
                                          color="black"
                                        />
                                      )}

                                    </ActionIcon>
                                  </Tooltip>
                                )}
                              </CopyButton>
                            )}
                        </div>
                        <div className="flex items-center gap-3 text-base font-normal">
                          {value?.icon
                            ? (
                              <img
                                className="w-11 h-11 rounded-full"
                                src={value?.icon || `${assetPrefix}/images/CrptoIcon.svg`}
                                alt="Crypto"
                              />
                            )
                            : <ReportMoney className="w-11 h-11" />}

                          <div className="flex flex-col gap-1">
                            <Tooltip label={value?.token.toUpperCase()} color="black" withArrow>
                              <span
                                className={`${styles.title} text-base`}
                              >
                                {value?.token?.length > 8 ? `${value?.token?.slice(0, 8)}...` : value?.token.toUpperCase() || '-'}
                              </span>
                            </Tooltip>
                            <span
                              className={`${styles.subTitle} text-sm`}
                            >
                              {value?.tradingProductType[0].toUpperCase() + value?.tradingProductType.slice(1)}
                            </span>
                          </div>
                        </div>
                        <div className="text-base font-normal flex items-start">
                          <Tooltip label={value?.quantity} disabled={value.quantity === 0} color="black" withArrow>
                            <span>
                              {renderNumber(value?.quantity)}
                            </span>
                          </Tooltip>
                        </div>
                        <div className={`text-base font-normal ${value?.currentPriceUsd > 0 ? 'text-green-500' : 'text-red-500'}`}>
                          <Tooltip label={value?.currentPriceUsd} disabled={value.currentPriceUsd === 0} color="black" withArrow>
                            <span>
                              {renderNumber(value?.currentPriceUsd, true)}
                            </span>
                          </Tooltip>
                        </div>
                        <div className="text-base font-normal">
                          <Tooltip label={value?.totalValueUsd} disabled={value.totalValueUsd === 0} color="black" withArrow>
                            <span>
                              {renderNumber(value?.totalValueUsd, true)}
                            </span>
                          </Tooltip>
                        </div>
                        <div className="text-base font-normal">
                          <Tooltip label={value?.dollarCostAvg} color="black" disabled={value.dollarCostAvg === 0} withArrow>
                            <span>
                              {renderNumber(value?.dollarCostAvg, true)}
                            </span>
                          </Tooltip>
                        </div>
                        {/* <div className={`flex text-base gap-2 font-normal ${value?.percentageChange24h !== 0 && (value?.percentageChange24h > 0 ? 'text-green-500' : 'text-red-500')}`}>
                          {value?.percentageChange24h ? (
                            <>
                              <img
                                className="w-4 h-4 mt-1"
                                src={value?.percentageChange24h > 0 ? `${assetPrefix}/images/GreenArrow.svg` : `${assetPrefix}/images/RedArrow.svg`}
                                alt="ArrowIcon"
                              />
                              {value?.percentageChange24h ? `${(value?.percentageChange24h.toFixed(2))}%` : '-'}
                            </>
                          ) : '-'}
                        </div> */}
                      </div>

                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </div>
  );
};

export default ColdWallet;
